define('SageDotCom/Components/Content/Buttons/PersonaButton',[
    "jquery",
    "score_bootstrap/Components/Button"
    ],
    function ($, baseButton) {
        function PersonaButton(scope, clickMessagesTransmitting, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
            Object.defineProperties(this, {
                $scope: {
                    enumerable: true, value: $(scope)
                }
            });

            var buttonScope = new baseButton(scope,
                clickMessagesTransmitting || [],
                stateChangeMessages || [],
                onShowMessagesPerformer || [],
                onHideMessagePerformer || []);

            $('.ipt-wrapper').on('click', this.$scope, function () {
                var currentURL = window.location.href;
                var personCustomButton = $(this).find('.ipt-button');
                var personaIndex = personCustomButton.attr("persona");
                var gateIDValue = personCustomButton.attr("gateid");

                if (personCustomButton.hasClass('ipt-notrack')) {
                    setLocalStorage(personaIndex, currentURL, gateIDValue);
                    localStorageTracking(false);
                } else {
                    setLocalStorage(personaIndex, currentURL, gateIDValue);
                    localStorageTracking(true);
                }
            });

            function setLocalStorage(personaIndex, currentURL, gateIDValue) {
                if (personaIndex) {
                    localStorage.setItem('persona', Number(personaIndex));
                }

                if (currentURL) {
                    localStorage.setItem('gatedPage', currentURL);
                }

                if (gateIDValue) {
                    localStorage.setItem('gateID', gateIDValue);
                }
            }

            function localStorageTracking(trackMeBool) {
                if (trackMeBool) {
                    var existing = localStorage.getItem('TrackMe');
                    if (existing) {
                        localStorage.removeItem('TrackMe');
                    }
                } else {
                    localStorage.setItem('TrackMe', 'n0Track');
                }
            }

            return buttonScope;
        }
        
        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new PersonaButton(args.scope, args.ClickMessagesTransmitting, args.StateChangeMessagesTransmitting, args.ShowActionMessages, args.HideActionMessages);
        };
    });
